 <template>
    <div style="background:white; height:100%">
        <div style=" display:flex; min-width:1200px; background:#fff;line-height:30px; border-bottom:2px solid #389;">
            <div style="display:flex;padding-top:3px">
                <div style=" font-size:12px;margin-left:8px;margin-right:5px">状态</div>
                <el-select v-model="v_chk" style="width:120px"  size="small" @change="qryTabData" >
                    <el-option   value="ALL" label='所有' > </el-option>
                    <el-option   value="Y" label='已完成' > </el-option>
                    <el-option   value="N" label='未入库' > </el-option>
                    <el-option   value="NO" label='未完成' > </el-option>
                </el-select>
                <div style="font-size:12px;margin-right:4px;margin-left:5px">字段</div>
                <el-select v-model="selparam"  placeholder="请选择列名"  filterable size="small" style="width:150px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.fhide=='N'"></el-option>
                    </span>
                </el-select>
                <el-select v-model="oper"  size="small" style="width:110px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" clearable  v-model="txtparam" size="small" @keyup.enter.native="qryTabData" style="width:200px;   ">
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input>     
                <el-select v-model="selparam2"  placeholder="请选择列名" filterable  size="small" style="width:150px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.fhide=='N'"></el-option>
                    </span>
                </el-select>
                <el-select v-model="oper2"  size="small" style="width:110px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" clearable  v-model="txtparam2" size="small" @keyup.enter.native="qryTabData" style="width:200px;   ">
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input>     
                <el-button icon="iconfont icon-xiashuangjiantou" @click="btnQry" style="margin-left:5px" type="text" size="mini"></el-button> 
                <el-dropdown @command="dropSel" split-button type="primary" size="small" style="margin-left:10px">更多功能
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">导出数据</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">字段设置</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                
            </div>
        </div> 
        <el-table  :data="tabData" 
            border                            
            disabled-hover
            class="custom-table-border"
            style="overflow:auto;margin-top:1px;font-size:12px; "
            size="small"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            :height="tabHeight" 
            :row-key="getRowKey"  
            :cell-style="cellStyle"
            :header-cell-style="headStyle"
            ref="tabref" 
            :row-class-name="tabRowClass"
            :cell-class-name="cellRowClass"
            @row-click="rowClick"
            highlight-current-row>
            <el-table-column type="index" label="序号" width="50" fixed></el-table-column>
            <el-table-column  label="采购订单" width="95" align="left"  fixed  show-overflow-tooltip  >
                <template slot-scope="scope"> 
                    <el-link :underline="false" @click="repShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row['IDNO']}}</div> </el-link>
                </template>
            </el-table-column>
            <el-table-column  label="采购日期" width="90" align="center"  fixed > 
                <template slot-scope="scope"><span v-text="scope.row['ORDDTTM']"></span></template>
            </el-table-column>
            <el-table-column  label="要求交货日期" width="100" align="left"  fixed  show-overflow-tooltip  prop="SHPDTTM">
                <template slot-scope="scope"><span v-text="scope.row['SHPDTTM']"></span></template>
            </el-table-column>
            <el-table-column  label="物料编码" width="80" align="left"  fixed   show-overflow-tooltip  >
                <template slot-scope="scope"><span v-text="scope.row['MATNO']"></span></template>
            </el-table-column>
            <el-table-column  label="物料名称" width="110" align="left"  fixed   show-overflow-tooltip  >
                <template slot-scope="scope"><span v-text="scope.row['MATNM']"></span></template>
            </el-table-column>
            <el-table-column v-for="(it,ind) in gpArr" :key="ind" :label="it.title"  align="center"  prop="ONETOP"  >   
                <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.gpno==it.key).filter(item=>item.thide=='N').filter(item=>!setKeyCol.includes(item['key']))" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"     
                    :min-width="item.width">
                    <template slot-scope="scope">
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" disabled false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
 
                        <div  v-else  v-text="scope.row[item.key]" ></div>
                    </template>
                </el-table-column>
            </el-table-column>
 
        </el-table>  
        <div style="margin-top:3px; overflow: hidden;display:flex;background:white; display:flex">
            <div style="float: left;padding-left:4px;font-size:12px">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:360px;display:flex ;">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:90px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:70px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
            </div>
            <div style="color:#606266;margin:7px 10px;margin-left:15px; font-size:12px;width:700px;font-weight:600; ">
                颜色说明：<span style="color:#808080">1、距交货期3天以上:灰色</span> 
                <span style="color:blue;margin-left:6px">2、距交货期3天之内:蓝色</span> 
                <span style="color:green;margin-left:6px">  3、已完成:绿色</span> 
                <span style="color:red;margin-left:6px"> 4、逾期:红色</span>
            </div>
        </div> 
 
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
        <!-- 高级查询功能 -->
        <el-dialog  v-dialogDrag   :visible.sync="findWin" width="710px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">高级查找</span>
            </div> 
            <adv-qry v-bind:v_idseq ="15794" v-bind:v_lstseq="2" @child-exit="btnExit" @child-query="filterQry"></adv-qry>                
        </el-dialog>  
        <!-- 字段设置 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="setWin" width="400px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段显示设置</span>
            </div> 
            <div style="height:80vh;overflow-y:auto;">
                <div style="line-height:30px;height:30px" v-for="(item,index) in fldArr" :key="index">
                    <el-checkbox  true-label="Y" false-label="N" v-model="item['VISFLAG']" >{{item['CNAME']}}</el-checkbox>
                </div>
            </div>
            <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px; ">
                <span style="float:right">
                    <el-button type="info" @click="setWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button   @click="setOk" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-baocun"  > 保存设置 </el-button> 
                </span>
            </div>  
        </el-dialog> 
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:v_random="v_random" v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- 明细资料框 -->
        <el-dialog v-dialogDrag  :visible.sync="dtlWin"  width="1000px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">跟进反馈</span>
            </div>
            <Form :model="dtlRow" :label-width="120"  label-position="right" inline  >  
                <div style="line-height:30px;height:30px;font-size:11px">批色办日期</div>
                <el-date-picker  type="date"  v-model="dtlRow['CLDTTM']" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                <div style="line-height:30px;height:30px;font-size:11px">批缸办日期</div>
                <el-date-picker  type="date"  v-model="dtlRow['VATDTTM']" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
                <div style="line-height:30px;height:30px;font-size:11px">说明备注</div>
                <el-input type="textarea" :rows="4" v-model="dtlRow['MRMK']" placeholder="请输入说明备注内容" ></el-input>
                <div style="line-height:30px;height:30px;font-size:11px">已完成</div>
                <el-checkbox true-label="Y"  false-label="N" v-model="dtlRow['STFG']" border style="width:100%"> &nbsp;</el-checkbox> 
            </Form> 
            <span slot="footer"  >
                <el-button type="info" @click="dtlWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                <el-button @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import advQry from '../datamgt/advqry.vue' 
import {getDate} from '../../api/Select' 
import repWin from '../datamgt/repWin.vue'
import pubWin from '../datamgt/pubwin.vue'
//局部注册
export default {
    name:"proc_query",
    data () {
        return {
            loadWin:false,
            repDlg:false,
            dtlWin:false,
            repWin:false,
            repUrl:'',
            setWin:false,
            addWin:false,
            perFlag:'create',
            contRow:{},
            v_random:'',
            promptWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            mainRow:{},
            menuList: [],
            openName:[], //模块ID集合
            listIndex:'-1',
            active:'', //二级菜单选中标志
            menuBool:false,
            disabled:false, //新增权限制
            dtlRow:{},
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            selparam2:'',
            oper2:'like',
            txtparam2:'',
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            ggArr:[],
   
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            findWin:false,
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            imgSrc:'',
 
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            operArr:[],
            initCol:[] , //初始化列
            v_loading:false,
            pageList: [ {
                value: 50,
                label: '50'
                }, 
                {
                value: 100,
                label: '100'
            }],
            setCol:[],
            setKeyCol:[],
            fldArr:[],
   
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            qtyRow:{},
            qtyFlag:'create',
            qtyWin:false,
 
            dtlData:[],
            chkIndex: 0,
        
            showFlag:true,
            gpArr:[],
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_tabRow:{},
            v_tabIndex:'',
            v_value2:'',
            v_key2:'',
            delDtlData:[],
            smpCol:[],
            tableCol:[],
            v_table:'',
            v_key:'',
            v_chk:'N',
            btnWin:false,
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','15794','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
 
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','15794','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
  
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 350) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 158) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        },
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    components: {
        advQry,
        repWin,
        pubWin,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        headStyle({row,column}){
            if (column.property=='ONETOP'  ){
                return 'color:#fff;background:#808695'
            }else if (column.property=='SHPDTTM'  ){
                return 'color:red;background:#ccc '
            }else{
                return 'color:#0C090A;background:#ccc '
            }
        },
        //单元格样式
        cellStyle({row,column}){
            if (column.property=='PCT' ){
                return {background:'linear-gradient(to right,#2e9bcfcc 0%,#4fcfd5cc '+row.PCT+',transparent 0%) !important',textAlign:'center'}
            }else{
                return {padding:'2px'}
            } 
        },
 
        btnSure(obj){
            if (this.v_key =='SMPNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{SMPNO:obj['SMPNO'],IDTY:obj['SMPTY'],STYNO:obj['STYNO'],STYNM:obj['STYNM'],GG:obj['GG'],CLNTNM:obj['CLNTNM'],
                        STKNM:obj['STKNM'],STKNO:obj['STKNO'],CCL:obj['CCL'],SZ:obj['SZ'],QTY:1,PLCNM:obj['PLCNM']} ))
            } 
            this.btnWin =false
        },
 
        dtlDel(row,index){
            this.delDtlData.push(row)
            this.dtlData.splice(index,1)
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (reftab=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'][0].setCurrentRow(this.dtlData[this.chkIndex])
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+'QTY'][0].focus()  
                    } 
                } 
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'][0].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refdtl'][0].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
        upLine(val){
            if (val =='down'){
                this.chkIndex = this.chkIndex +1          
                if (this.chkIndex >=this.tabData.length) {
                    this.chkIndex =0
                }
                this.$refs['tabref'].setCurrentRow(this.tabData[this.chkIndex])
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                this.$refs['tabref'].setCurrentRow(this.tabData[this.chkIndex])
            }      
        },
        //表格行 选择框
        inputBtn( row, index, key){
            this.v_key =key
            this.v_tabRow =row
            this.v_tabIndex =index
            this.v_random=Math.random()
            if (key =='SMPNO'){ //样办单号
                this.v_table ='v_SMP_STKLOG'
                this.tableCol =this.smpCol
                this.v_key2 ='stkno'
                this.v_value2 =this.mainRow['STKNO']
            } 
            this.btnWin =true
        },
        getRowClick(row){
            this.chkIndex =row.index
        },
        cellRowClass({row,column,rowIndex,columnIndex}){  //为 table数据添加 index 字段
 
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            //颜色说明： 1、距交货期3天以上:黑色  2、距交货期3天之内:蓝色  3、已完成:绿色 4、逾期:红色
            if (row['STKSTFG']=='Y') {  //FINISH
                return 'green-row';
            }else{  //未完成分支
              let diffDays = this.$moment(row['SHPDTTM']).diff(this.$moment(getDate('day')), 'days')
              if (diffDays<0) {   //逾期
                return 'red-row';
              }else if (diffDays<=3 && diffDays>=0) {   //距交货期3天之内
                return 'blue-row';
              }else{
                  return 'gray-row'
              }
            }
        },
        getDtlKey(row){
            return  row.index  
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+'rep_poord.cpt' +'&p_corpid='+row['CORPID']+'&p_idno=' +row['IDNO']
        },
 
 
        //图片预览
        imgPreview(path){
            if (path &&path.lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            }
        },
        imgDel(idseq,lstseq,path,index){
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:idseq,p_key2:'lstseq',p_value2:lstseq,p_key5:'filepath', p_value5:path,p_table:'BS_img'},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        this.imgData.splice(index, 1);          
                    }else{
                        this.prompt=res.result
                        this.promptWin=true
                    }        
                })    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        }, 
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出10M' 
        },
         //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择 PDF或图片格式'
        },
        successFile(res,file){
            this.videoUploadPercent=0
            this.videoFlag = false
            let v_filename='/assets/basedict/'+this.fileName+file.name.substring(file.name.lastIndexOf('.'))
            this.imgData.push({'IMGTY':'YARN','IMGPATH':v_filename,'CNAME':file.name})                   
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {             
            this.fileName= this.v_username+getDate('year')     
            this.uploadData = {
                code: this.fileName ,
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise;  
        },
        //字段设置保存
        setOk(){  
            for(var k=0;k<this.fldArr.length;k++){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/tableBodySave',
                    data: {p_json:JSON.stringify(Object.assign(this.fldArr[k] )), p_table:'form_fldset',p_idseq:''},
                }).then(res =>{
                    this.getSetList()
                })
            }
            this.setWin =false
        },
        //split-button 下拉选项
        dropSel(val){
            if (val =='expdata'){ //导出数据
                this.loadWin =true   
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'15794',p_lstseq:'2',p_json:JSON.stringify(this.allData),p_action:'采购进度查询'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = '采购进度查询_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin =false
                }) 
            }else if (val =='fldset'){  //字段设置显示--隐藏
                this.fldArr =[]
                this.initCol.filter(item=>item.THIDE=='N').forEach(item =>{
                    if (this.setCol.length>0) {
                        let v_row = ''
                        this.setCol.some(it =>{
                            if (it['FLDNO'] ==item['FLDNO'] ) {
                                v_row =it
                            }
                        })
                        if (v_row ){
                            let v_obj ={'IDSEQ':'15794','LSTSEQ':v_row['LSTSEQ'],CORPID:this.v_corpid,USERNO:this.v_username,CODE:item['FLDNO'],CNAME:item['FLDNM'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ'],REFITMSEQ:item['ITMSEQ'],'VISFLAG':v_row['VISFLAG']}
                            this.fldArr.push(v_obj)
                        }else {   
                            let v_obj ={'IDSEQ':'15794','LSTSEQ':'',CORPID:this.v_corpid,USERNO:this.v_username,CODE:item['FLDNO'],CNAME:item['FLDNM'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ'],REFITMSEQ:item['ITMSEQ'],'VISFLAG':'Y'}
                            this.fldArr.push(v_obj)
                        }          
                    }else{
                        let v_obj ={'IDSEQ':'15794',LSTSEQ:'',CORPID:this.v_corpid,USERNO:this.v_username,CODE:item['FLDNO'],CNAME:item['FLDNM'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ'],REFITMSEQ:item['ITMSEQ'],'VISFLAG':'Y'}
                        this.fldArr.push(v_obj)
                    }
                })
                this.setWin =true               
            }
        },
        //高级查找窗口
        btnQry(){
            this.findWin =true
        },
        btnExit(){
            this.findWin =false
        },
        //高级查询
        filterQry(v_cond){
            this.findWin =false
            this.getTabList( v_cond)           
        },
 
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='C')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
            this.chkIndex =row.index
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'15794',p_key2:'',p_value2:'',p_key3:'edcss',p_value3:'select',p_cond:' and lstseq in (1,2)'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base',' and (corpno=\''+this.v_corpid+'\' or corpno is null )').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            let v_cond =' set stfg=\''+this.dtlRow['STFG']+'\',CLDTTM=\''+this.dtlRow['CLDTTM']+'\',VATDTTM=\''+this.dtlRow['VATDTTM']+'\',MRMK=\''+this.dtlRow['MRMK']+'\''
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.dtlRow['IDSEQ'],p_key2:'lstseq',p_value2:this.dtlRow['LSTSEQ'],p_table:'po_orddtl',p_cond:v_cond },
            }).then(res=>{ 
                if (res.code=='200') {
                    this.tabData.splice(this.v_tabIndex,1,Object.assign(this.dtlRow,{'STFG':this.dtlRow['STFG'],CLDTTM:this.dtlRow['CLDTTM'],VATDTTM:this.dtlRow['VATDTTM'],MRMK:this.dtlRow['MRMK']}))
                    this.dtlWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
            
        },
 
        //查询明细
        getTabList(cond){
            this.v_loading =true     
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam+' desc',p_table:'V_PO_ORDQRY'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs['tabref'].doLayout()
                        if (this.allData.length>0){
                            this.$refs['tabref'].setCurrentRow(this.allData[0])
                        }
                        this.v_loading =false
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                    this.v_loading =false
                }               
            }) 
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
 
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        selRec(row){

        },
        editRec(row ,index){
            this.v_tabIndex =index
            this.dtlRow =JSON.parse(JSON.stringify(row))    
            this.dtlWin=true           
        },
        qryFileList(idseq){
            this.imgData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq', p_value:idseq,p_cond: ' order by SORTBY,LSTSEQ desc',p_table:'V_BS_IMG'},
            }).then(res=>{ 
                this.imgData =res.result
            })
        },
        getRowKey(row){
            return row.IDSEQ+'-'+row['LSTSEQ']
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
            if (this.v_chk!=='ALL'){
                cond_=cond_+' and STKstfg=\''+this.v_chk+'\''
            }  
            this.getTabList(cond_)
        },
 
        //用户界面字段列表
        getSetList(){
            getTabColOrData(this.v_url,'V_FORM_FLDSET','idseq','15794','userno',this.v_username).then((res) => {
                this.setCol =res.result
                this.setKeyCol =[]
                res.result.forEach(item=>{
                    if (item['VISFLAG'] =='N') {
                        this.setKeyCol.push(item['FLDNO'])
                    }
                }) 
            })
        },               
        //获取表列字段
        getTabField(){
            let vm =this
            this.getSetList()
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15794','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                this.initCol =res.result
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        gpno:res.result[k].GPNO,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'V_SYS_FORM_FLDGP','idseq','15794','lstseq','2','','',' order by  sortby').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.gpArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].GPNM,
                        key:res.result[k].GPNO
                    })
                }
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:12px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-row {
        width: 97%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table .red-row{
        color:red;
    }.el-table .green-row  {
        color: green;
    }.el-table .blue-row  {
        color: blue;
    }.el-table .gray-row  {
        color: #808080;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 